// The inline alert, in one place.
//
// This markup was copy-pasted 17 times across the Products feature alone,
// in two slightly-different sizes, each with its own hand-tuned padding and
// its own 7px dot. Seventeen copies is seventeen chances for the next edit
// to land on only sixteen of them.
import React from 'react';

export type AlertTone = 'destructive' | 'warning' | 'info';

const TONE: Record<AlertTone, { surface: string; dot: string }> = {
  destructive: { surface: 'bg-destructive-bg text-destructive', dot: 'bg-destructive' },
  warning: { surface: 'bg-warning-bg text-warning', dot: 'bg-warning' },
  info: { surface: 'bg-primary-100 text-primary', dot: 'bg-primary' },
};

export interface AlertProps {
  children: React.ReactNode;
  tone?: AlertTone;
  /** Renders a Retry affordance at the end of the row when provided. */
  onRetry?: () => void;
  className?: string;
}

export function Alert({
  children,
  tone = 'destructive',
  onRetry,
  className = '',
}: AlertProps): React.ReactElement {
  const { surface, dot } = TONE[tone];
  return (
    <div
      role="alert"
      className={`flex items-start gap-2.5 rounded-field px-3.5 py-2.5 text-body ${surface} ${className}`}
    >
      <span className={`mt-1.5 h-[7px] w-[7px] shrink-0 rounded-full ${dot}`} aria-hidden="true" />
      <span className="flex-1">{children}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 text-label underline underline-offset-2 hover:no-underline"
        >
          Retry
        </button>
      )}
    </div>
  );
}
